import React, { useState, useRef, useEffect } from "react";
import EmojiPicker from "emoji-picker-react";
import videoIcon from "../../assets/images/video-icon.png";
import smile from "../../assets/images/smile.png";
import hashtag from "../../assets/images/hashtag.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImage } from "@fortawesome/free-regular-svg-icons";
import { useDispatch } from "react-redux";
import {
  createPost,
  feedImageUpload,
  getFeed,
} from "../../features/slices/feedmanagement";// Adjust the path as per your project structure
import LoaderForImage from "../LoaderForImage";

const CreatePost = ({ setUpdateState }) => {
  const inputRef = useRef();
  const emojiPickerRef = useRef();
  const [postText, setPostText] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [file, setFile] = useState("");
  const [contentType, setContentType] = useState("");
  const [loading, setLoading] = useState(false); // Add loading state
  const dispatch = useDispatch();
  const textareaRef = useRef(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  }, [postText]);

  const handleClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      showCreatePost: false,
    }));
  };

  const handleClick = () => {
    inputRef.current.click();
  };

  const onEmojiClick = (event, emojiObject) => {
    setPostText((prevText) => prevText + emojiObject.emoji);
    setShowEmojiPicker(false);
  };

  const handleChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const imageUrl = URL.createObjectURL(file);
      if (imageUrl) {
        const formData = new FormData();
        formData.append("fileName", file);
        setLoading(true); // Start loader
        dispatch(feedImageUpload(formData)).then((result) => {
          setLoading(false); // Stop loader
          if (result?.payload?.code === 200) {
            setFile(result?.payload?.url);
            if (file.type.startsWith("image/")) {
              setContentType("image");
            } else if (file.type.startsWith("video/")) {
              setContentType("video");
            } else {
              setContentType("other");
            }
          }
        });
      }
    }
  };

  const handlePost = () => {
    const data = {
      text: postText,
      contentUrl: file,
      contentType: contentType,
    };
    setLoading(true); // Start loader
    dispatch(createPost(data)).then((res) => {
      setLoading(false); // Stop loader
      if (res?.payload?.code === 200) {
        dispatch(getFeed({ page: 1 }));
        handleClose();
      }
    });
  };

  const handleHash = () => {
    setPostText((prevText) => prevText + " #");
  };

  useEffect(() => {
    const data = postText.split("#");
    console.log({ data });
  }, [postText]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };

    if (showEmojiPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showEmojiPicker]);

  return (
    <>
      <div className="ModalBox">
        <div
          id="CreatePost"
          className="modal fade show"
          role="dialog"
          aria-modal="true"
          style={{ paddingRight: 22, display: "block" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Category">
                  <a className="CloseModal" onClick={handleClose}>
                    ×
                  </a>
                  <h3>Create Post</h3>
                  <div className="CreatePostArea">
                    <textarea
                      ref={textareaRef}
                      className="form-control"
                      placeholder="Write something here..."
                      value={postText}
                      onChange={(e) => setPostText(e.target.value)}
                      style={{
                        minHeight: "100px",
                        overflow: "hidden",
                        resize: "none",
                        outline: "none",
                        paddingBottom: !contentType ? "99px" : "10px",
                      }}
                    />

                    {/* Display loader or media preview */}
                    {loading ? (
                      <LoaderForImage length={250} width={"475px"} />
                    ) : (
                      <>
                        {contentType === "image" && (
                          <div>
                            <img
                              src={file}
                              alt="Uploaded Image"
                              style={{
                                width: "100%",
                                marginTop: "10px",
                                marginBottom: "107px",
                                height: "313px",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        )}
                        {contentType === "video" && (
                          <div>
                            <video
                              controls
                              controlsList="nodownload"
                              style={{
                                width: "100%",
                                marginTop: "10px",
                                marginBottom: "107px",
                                height: "313px",
                                objectFit: "contain",
                              }}
                            >
                              <source src={file} type="video/mp4" />
                            </video>
                          </div>
                        )}
                      </>
                    )}

                    <div className="PostBox">
                      <ul>
                        <li>
                          <a href="javascript:void(0);">
                            <img
                              src={hashtag}
                              className="smallImg"
                              alt="Hashtag Icon"
                              onClick={handleHash}
                            />
                          </a>
                        </li>
                        <li style={{ position: "relative" }}>
                          <a
                            href="javascript:void(0);"
                            onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                          >
                            <img
                              src={smile}
                              className="smallImg"
                              alt="Emoji Icon"
                            />
                          </a>
                          {showEmojiPicker && (
                            <div
                              ref={emojiPickerRef}
                              style={{
                                position: "absolute",
                                left: "50%",
                                top: "20%",
                                zIndex: "9999",
                              }}
                            >
                              <EmojiPicker onEmojiClick={onEmojiClick} />
                            </div>
                          )}
                        </li>
                        <li>
                          <input
                            type="file"
                            accept="image/*, video/*"
                            ref={inputRef}
                            style={{ display: "none" }}
                            disabled={loading}
                            onChange={handleChange}
                          />
                          <a onClick={handleClick}>
                            <FontAwesomeIcon
                              icon={faImage}
                              size="xl"
                              style={{ color: "#ff5828", marginTop: "5px" }}
                            />
                          </a>
                        </li>
                      </ul>
                      <button
                        className="PostBtn"
                        onClick={handlePost}
                        // Disable button when loading
                      >
                        Post
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreatePost;
